/**
 * Centralizes catalog epoch-millisecond interpretation so the three
 * title-facing consumers cannot drift back to conflicting conversions.
 */
import { DateTime } from 'luxon';

export const epochToIsoDate = (
  epoch: number | null | undefined,
): string | undefined => {
  if (epoch == null) return undefined;

  const dateTime = DateTime.fromMillis(epoch, { zone: 'utc' });
  if (!dateTime.isValid) return undefined;

  return dateTime.toISO({ suppressMilliseconds: false }) ?? undefined;
};
